import React, {useCallback, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from '@material-ui/icons/Search';
// import FilterListIcon from '@material-ui/icons/FilterList';
import { Redirect } from 'react-router-dom';

import {convertStateToURLQueryString} from '../course-group/courseGroupSearchScreen';
import {getCourseGroupSearchUrl} from '../../utils';
import {GROUP_SEARCH_DEFAULT_PARAMS} from '../../constants';
import {CourseCategory} from "../../models/enums";
import {FormControl, Select} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container:{
        width: '100%',
    },
    root: {
        padding: '0px 5px',
        display: 'flex',
        alignItems: 'center',
        minWidth: '50%',
        marginTop: 20
    },
    input: {
        fontSize: '1.25em',
        [theme.breakpoints.down('sm')]: {fontSize: '1.2em'},
        [theme.breakpoints.down('xs')]: {fontSize: '1.15em'},
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    Button: {
        fontSize: '1.3em',
        [theme.breakpoints.down('sm')]: {fontSize: '1.25em'},
        [theme.breakpoints.down('xs')]: {fontSize: '1.2em'},
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    hideSelectedList:{
        width: 0,
        height: 0,
        overflow: 'hidden'
    },
    categoryMenuPaper: {
        maxHeight: '80vh',
    },
    categoryMenuList: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        columnGap: '8px',
    },
}));

export default function HomeSearchBar() {
    const classes = useStyles();
    const [keyword, setKeyword] = useState('');
    const [searchUrl, setSearchUrl] = useState(null);
    const [categoryOpen, setCategoryOpen] = useState(false);

    const handleCloseCategory = () => {
        setCategoryOpen(false);
    };

    const handleOpenCategory = () => {
        setCategoryOpen(true);
    };

    const handleSearchByCategory = useCallback(event => {
        event.preventDefault();
        const redirectUrl = getCourseGroupSearchUrl(convertStateToURLQueryString({
            ...GROUP_SEARCH_DEFAULT_PARAMS,
            category: event.target.value
        }));
        setSearchUrl(redirectUrl);
    }, [setSearchUrl]);

    const handleSearch = useCallback(event => {
        event.preventDefault();
        if(keyword !== ''){
            const redirectUrl = getCourseGroupSearchUrl(convertStateToURLQueryString({
                ...GROUP_SEARCH_DEFAULT_PARAMS,
                query: keyword
            }));
            setSearchUrl(redirectUrl);
        }
    }, [keyword, setSearchUrl]);

    return (
        <FormControl className={classes.container} onSubmit={handleSearch}>
            {searchUrl && <Redirect push to={searchUrl}/>}
            <Paper component="form" className={classes.root}>
                <Button color="primary" className={classes.Button} aria-label="搜尋範疇"
                            onClick={handleOpenCategory}>
                    搜尋範疇
                </Button>
                <Divider className={classes.divider} orientation="vertical"/>
                    <Select
                        className={classes.hideSelectedList}
                        value=""
                        open={categoryOpen}
                        onOpen={handleOpenCategory}
                        onClose={handleCloseCategory}
                        onChange={handleSearchByCategory}
                        MenuProps={{
                            PaperProps: {
                                className: classes.categoryMenuPaper,
                            },
                            MenuListProps: {
                                className: classes.categoryMenuList,
                            },
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                        }}
                    >
                        {Object.entries(CourseCategory).map(([category, value]) => (
                            <MenuItem key={category} value={category}>{value.displayName}</MenuItem>
                        ))}
                    </Select>
                <IconButton type="submit" aria-label="search">
                    <SearchIcon/>
                </IconButton>
                <InputBase
                    className={classes.input}
                    placeholder="關鍵字"
                    inputProps={{'aria-label': '關鍵字搜尋'}}
                    value={keyword}
                    onInput={e => setKeyword(e.target.value)}
                />                
            </Paper>
        </FormControl>
    );
}
